import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { media } from 'ui/rwd'
import { CONTENT_WIDTH, pageGutter } from '../HomepageStyledComponents'

const CredibilitySection = styled.div`
  width: 100%;
  max-width: ${CONTENT_WIDTH};
  margin: 0 auto;
  ${pageGutter};
  padding-top: 0;
  padding-bottom: 0;
`

const CredibilityViewport = styled.div`
  overflow: hidden;
  border-top: 1px solid ${theme('lightGray')};
  border-bottom: 1px solid ${theme('lightGray')};
  -webkit-mask-image: linear-gradient(
    to right,
    transparent,
    #000 1.5rem,
    #000 calc(100% - 1.5rem),
    transparent
  );
  mask-image: linear-gradient(to right, transparent, #000 1.5rem, #000 calc(100% - 1.5rem), transparent);

  ${media.sm`
    -webkit-mask-image: linear-gradient(
      to right,
      transparent,
      #000 2.5rem,
      #000 calc(100% - 2.5rem),
      transparent
    );
    mask-image: linear-gradient(to right, transparent, #000 2.5rem, #000 calc(100% - 2.5rem), transparent);
  `}
`

const CredibilityTrack = styled.div`
  display: flex;
  width: max-content;
  animation: credibilityMarquee 40s linear infinite;

  &:hover {
    animation-play-state: paused;
  }

  @keyframes credibilityMarquee {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-50%);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

const CredibilityInner = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 1.5rem;
  padding: 0.95rem 1.5rem 0.95rem 0;
`

const CredibilityItem = styled.span`
  flex: 0 0 auto;
  font-size: 0.8125rem;
  letter-spacing: 0.02em;
  line-height: 1.4;
  white-space: nowrap;
  color: ${theme('mineShaft')};

  ${media.sm`
    font-size: 0.875rem;
  `}
`

const CredibilityDot = styled.span`
  flex: 0 0 auto;
  width: 0.28rem;
  height: 0.28rem;
  border-radius: 50%;
  background-color: ${theme('gray')};
`

export {
  CredibilitySection,
  CredibilityViewport,
  CredibilityTrack,
  CredibilityInner,
  CredibilityItem,
  CredibilityDot
}
